const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787'

type PlatformPageView = {
  path: string
  routeName: string
}

function randomId(prefix: string) {
  const cryptoId = globalThis.crypto?.randomUUID?.()
  return `${prefix}_${cryptoId || `${Date.now()}_${Math.random().toString(36).slice(2)}`}`
}

function storedId(storage: Storage, key: string, prefix: string) {
  let value = storage.getItem(key)
  if (!value) {
    value = randomId(prefix)
    storage.setItem(key, value)
  }
  return value
}

function visitorId() {
  try {
    return storedId(localStorage, 'vte_platform_visitor_id', 'v')
  } catch {
    return randomId('v')
  }
}

function sessionId() {
  try {
    return storedId(sessionStorage, 'vte_platform_session_id', 's')
  } catch {
    return randomId('s')
  }
}

function utmParams() {
  const params = new URLSearchParams(window.location.search)
  return {
    utm_source: params.get('utm_source') || undefined,
    utm_medium: params.get('utm_medium') || undefined,
    utm_campaign: params.get('utm_campaign') || undefined,
    utm_term: params.get('utm_term') || undefined,
    utm_content: params.get('utm_content') || undefined,
    utm_id: params.get('utm_id') || undefined,
  }
}

export function trackPlatformPageView(event: PlatformPageView) {
  const body = {
    app: 'dashboard',
    event_type: 'page_view',
    path: event.path,
    route_name: event.routeName,
    visitor_id: visitorId(),
    session_id: sessionId(),
    referrer: document.referrer || undefined,
    ...utmParams(),
  }

  const headers: Record<string, string> = { 'Content-Type': 'application/json' }
  const token = localStorage.getItem('vte_access_token')
  if (token) headers.Authorization = `Bearer ${token}`

  fetch(`${API_URL}/api/platform-analytics/events`, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
    credentials: 'include',
    keepalive: true,
  }).catch(() => {})
}
